import { staticSelector } from 'ducks/static'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import {
  Container,
  Content,
  Title,
  CardDesign,
  Left,
  LeftIconContainer,
  Icon,
  TextContainer,
  Info,
  Vector,
  Right,
  RightIconContainer,
  InfoGrey,
  InfoGreen,
} from '../styledCard'
import vector from 'assets/Vector6.png'
import { Metric } from '../../MetricsPage/types'

interface Props {
  data: Metric
}

export const Card1: FC<Props> = ({ data }) => {
  const state = useSelector(staticSelector)

  const { iconLeft, iconRight } = state.content?.nationalMetric.subTabRender[0]

  return (
    <Container>
      <Content>
        {/* {title ? <Title>{title}</Title> : null} */}
        <CardDesign>
          <Left>
            <LeftIconContainer leftColor="#7D8C9A">
              {iconLeft.url ? <Icon src={iconLeft.url} /> : null}
            </LeftIconContainer>
            <TextContainer>
              <>
                <Info>
                  <InfoGrey leftColor="#7D8C9A">{data.greenhouse} lbs of CO2</InfoGrey>
                  Total $ savings of <InfoGrey>${data.greenhouse_money}.</InfoGrey>
                </Info>
              </>
            </TextContainer>
          </Left>
          <Vector src={vector} />
          <Right>
            <RightIconContainer rightColor="#54AE2A">
              {iconRight.url ? <Icon src={iconRight.url} /> : null}
            </RightIconContainer>
            <TextContainer>
              <Info>
                That’s the equivalent of <InfoGreen>planting {data.greenhouse_visual} acres</InfoGreen> of urban trees
              </Info>
            </TextContainer>
          </Right>
        </CardDesign>
      </Content>
    </Container>
  )
}
